import { Logger } from "logging";

export function delayOnOutsideClick(logger: Logger, isOpen: boolean, setIsOpen: (state: boolean) => void) {
  if (isOpen) {
    setTimeout(() => {
      logger.debug("detected outside click, closing...");
      setIsOpen(false);
    }, 10);
  }
}
